import { cn } from '@/lib/utils';
import { FC } from 'react';

export const TableSkeleton: FC<{ columns: number }> = ({ columns }) => {
  return (
    <>
      {Array.from({ length: 8 }).map((_, rowIndex) => (
        <tr key={rowIndex} className="border-b last:border-none">
          {Array.from({ length: columns }).map((_, colIndex) => (
            <td
              key={colIndex}
              className={cn('px-4 py-3', colIndex > 1 && 'text-center')}
            >
              <div
                className={cn(
                  'h-4 bg-gray-200 rounded animate-pulse',
                  colIndex === 0 && 'w-8',
                  colIndex === 1 && 'w-32',
                  colIndex > 1 && 'w-16 mx-auto',
                )}
              />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};
